import React from 'react';
import styles from './SparklesIcon.module.css';

const SparklesIcon = ({ isActive, size = 20, className = '' }) => {
  // Conditionally apply the 'active' class for the fade effect
  const gradientPathClasses = `${styles.gradientPath} ${
    isActive ? styles.active : ''
  }`;

  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'>
      <defs>
        {/* Define the gradient we want to use */}
        <linearGradient
          id='sparkles-gradient'
          x1='50%'
          y1='0%'
          x2='50%'
          y2='100%'>
          <stop offset='0%' stopColor='white' />
          <stop offset='40%' stopColor='white' />
          <stop offset='100%' stopColor='#38495a' />
        </linearGradient>
      </defs>

      {/* Version 1: The standard white icon */}
      <g stroke='white'>
        <path d='M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z' />
        <path d='M20 2v4' />
        <path d='M22 4h-4' />
        <circle cx='4' cy='20' r='2' />
      </g>

      {/* Version 2: The gradient icon (initially invisible) */}
      <g stroke='url(#sparkles-gradient)' className={gradientPathClasses}>
        <path d='M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z' />
        <path d='M20 2v4' />
        <path d='M22 4h-4' />
        <circle cx='4' cy='20' r='2' />
      </g>
    </svg>
  );
};

export default SparklesIcon;
